// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'Check transfer to cashier'"></sub-header>

    <h2 class="section-header">Please confirm the following:</h2>
    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table">
        <tbody>
          <tr>
            <td>1.</td>
            <td>Cashier name:</td>
            <td>
              <div class="form-section-field">
              <user-select
                  ng-model="\$ctrl.transaction.approvalUserId"
                  users="\$ctrl.approvalUsers"
                  ng-required="true"
              >
              </user-select>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <check-list-wrapper transfer-status="'TRANSFERRED_TO_TELLER'"
                          allow-late-checks="true"
                          ng-if="!\$ctrl.submitting"
                          on-check-change="\$ctrl.onCheckChange(checkedRecords)">
      </check-list-wrapper>

      <table class="misc-transaction__table table">
        <thead>
          <tr>
            <th></th>
            <th>Check amount to transfer:</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1.</td>
            <td>Amount to transfer:</td>
            <td>
              <cash ng-model="\$ctrl.transaction.amount"
                ng-required="true"
                ng-disabled="true"></cash>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="check-control-buttons buttons">
        <button
          class="misc-transaction__cancel btn btn-warning"
          ng-disabled="\$ctrl.transactionForm.\$pristine"
          ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button
          type="submit"
          class="misc-transaction__save btn btn-primary"
          ng-disabled="\$ctrl.transactionForm.\$invalid || \$ctrl.transaction.checkIds.length === 0 || \$ctrl.submitting"
          ng-click="\$ctrl.save()">
          Transfer now
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/check-transfer-to-cashier/check-transfer-to-cashier.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;